var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0.200195C18.273 0.200195 19.4939 0.705908 20.3941 1.60608C21.2942 2.50626 21.7999 3.72716 21.7999 5.0002V17.0002C21.7999 18.2732 21.2942 19.4941 20.3941 20.3943C19.4939 21.2945 18.273 21.8002 17 21.8002H4.99995C3.72691 21.8002 2.50601 21.2945 1.60584 20.3943C0.705664 19.4941 0.199951 18.2732 0.199951 17.0002V5.0002C0.199951 3.72716 0.705664 2.50626 1.60584 1.60608C2.50601 0.705908 3.72691 0.200195 4.99995 0.200195H17ZM17 6.20019L9.42555 13.7746L6.43995 10.789L5.42235 11.8066L9.42555 15.8002L18.0175 7.2082L17 6.20019Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckedIcon);
export default __webpack_public_path__ + "static/media/checkboxChecked_icon.a5cb0d99edd3ed4be2cbe7fa8224a8cc.svg";
export { ForwardRef as ReactComponent };